/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReasonForRefusal = {
    NoConsultingBackground: 'NO_CONSULTING_BACKGROUND',
    LessThanTwoYearsInTheConsultingIndustry: 'LESS_THAN_TWO_YEARS_IN_THE_CONSULTING_INDUSTRY',
    ItProfile: 'IT_PROFILE',
    FullTimeEmployment: 'FULL_TIME_EMPLOYMENT'
} as const;
export type ReasonForRefusal = typeof ReasonForRefusal[keyof typeof ReasonForRefusal];


export function instanceOfReasonForRefusal(value: any): boolean {
    for (const key in ReasonForRefusal) {
        if (Object.prototype.hasOwnProperty.call(ReasonForRefusal, key)) {
            // @ts-ignore
            if (ReasonForRefusal[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReasonForRefusalFromJSON(json: any): ReasonForRefusal {
    return ReasonForRefusalFromJSONTyped(json, false);
}

export function ReasonForRefusalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReasonForRefusal {
    return json as ReasonForRefusal;
}

export function ReasonForRefusalToJSON(value?: ReasonForRefusal | null): any {
    return value as any;
}

